export default "__VITE_ASSET__ff8c5e48__"